module.exports = __webpack_public_path__ + "img/app_logo_def.8eb94986.png";